/**
 * Tendências da operadora (Grafana) em link próprio, com o painel em tela cheia — Nexora Grid (GUS-1509).
 *
 * Criado em: 18/10/2026 · Última modificação: 18/10/2026 · Versão: 1.0.0
 *
 * Retorno de 18/10/2026: as tendências saem da visão geral (tela nova do CCO) para `/cco/tendencias`. O clique num
 * painel abre em tela cheia, com "Voltar" e Esc. Painéis do dashboard "CCO · Visão geral" (só leem o hub).
 */
import { useState } from "react";
import { useCco } from "./contexto";
import { LinkGrafana, PainelExpansivel, SeletorPeriodo } from "./PainelGrafana";

const PAINEIS: [number, string][] = [[1, "Nível dos reservatórios"], [2, "Vazão distribuída"], [3, "Potência total das bombas"], [4, "Pressão mínima na rede"]];

export function Tendencias() {
  const { empresa } = useCco();
  const [de, setDe] = useState("now-24h");
  if (!empresa) return <p className="nx-suave">Escolha uma operadora.</p>;
  return (
    <section className="nx-cartao tendencias-pagina" aria-label="Tendências">
      <h3>Tendências <SeletorPeriodo valor={de} aoMudar={setDe} /><span className="nx-suave">clique num gráfico para tela cheia</span>
        <LinkGrafana empresa={empresa} uid="nexora-cco-visao" de={de}>abrir no Grafana ›</LinkGrafana></h3>
      <div className="grade-paineis">
        {PAINEIS.map(([id, titulo]) => <PainelExpansivel key={id} empresa={empresa} uid="nexora-cco-visao" painel={id} titulo={titulo} de={de} altura={320} />)}
      </div>
    </section>
  );
}
